<template>
  <!-- Container -->
  <div class="container"
    :style="setCssCustP"
    :class="divClassList"
    @click="clicked"
    @mouseover="hoverOn"
    @mouseleave="hoverOff"    
  >
    <!-- Line -->
    <div class="line cursor-nosel"/>

    <!-- Items -->
    <template v-for="(item, index) in content" :key="item.ID">
      <tLineItem :content="item" :styles="styles" :index="index"/>
    </template>
  </div>
</template>

<script>
import tLineItem from './tLineItem.vue'

export default {
  name: 'default',
  components: {
    tLineItem,
  },
  props : {
    content: Object,
    styles: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
        hover: false,
    }
  },
  computed : {
    id() {
      return this.content?.id || ""
    },
    divClassList() {
      // Import & defaults
      let importOBJ = this.$styles.get(this.styles)
      let iBg = importOBJ.bg || "l"
      iBg = "bg-" + iBg
      let iSize = importOBJ.size || "m"
      iSize = "height-" + iSize

      return ['cursor-nosel', iBg, iSize]
    },
    setCssCustP() {
      // General
      let importOBJ = this.$styles.get(this.styles)
      let iSize = importOBJ.size || "m"
      let lineOffSet = `--lineOffset: calc(var(--item-${iSize}) * 0.6rem);`

      return [lineOffSet]
    },
  },
  methods: {
      hoverOn() {
        this.hover = true   
        this.$emit('events', 'hoverOn', this.id)
      },
      hoverOff() {
        this.hover = false
        this.$emit('events', 'hoverOff', this.id)
      },
      clicked() {
        this.$emit('events', 'clicked', this.id)
      },
  },
}
</script>

<style scoped>
.line {
  height: 2px;
  position: relative;
  top : var(--lineOffset);
  background-color: var(--main-l);
}
.container:hover .line {
  background-color: var(--main-m);
}
</style>